import { FORMAS_DE_PAGAMENTO, FORMA_DE_PAGAMENTO_LABELS, type FormaDePagamento } from "@bookdental/schemas";

export type Pagamento = { vencimento: string; pago: boolean; pagoEm: string; forma: FormaDePagamento | "" };

const campo =
  "h-9 w-full rounded-md border border-zinc-200 bg-white px-3 text-sm text-zinc-900 focus:border-brand-500 focus:outline-none focus:ring-1 focus:ring-brand-500 dark:border-border dark:bg-card dark:text-foreground";
const rotulo = "mb-1 block text-xs font-medium text-zinc-600 dark:text-muted-foreground";

/** Só com o financeiro: a compra vira uma conta a pagar (ou já paga) em "Materiais e insumos". */
export function PagamentoDaCompra({ valor, onChange }: { valor: Pagamento; onChange: (p: Pagamento) => void }) {
  return (
    <div className="space-y-2 rounded-md border border-zinc-200 p-2.5 dark:border-border">
      <p className="text-[12.5px] font-medium text-zinc-700 dark:text-foreground/80">
        Pagamento
        <span className="block text-[11px] font-normal text-zinc-500 dark:text-muted-foreground">A compra entra no financeiro como conta a pagar.</span>
      </p>
      <div className="grid gap-2 sm:grid-cols-3">
        <label>
          <span className={rotulo}>Vencimento</span>
          <input type="date" value={valor.vencimento} onChange={(e) => onChange({ ...valor, vencimento: e.target.value })} className={campo} />
        </label>
        <label className="flex items-end gap-2 pb-2 text-[12.5px] text-zinc-700 sm:col-span-2 dark:text-foreground/80">
          <input type="checkbox" checked={valor.pago} onChange={(e) => onChange({ ...valor, pago: e.target.checked })} className="mb-0.5" />
          Já foi paga
        </label>
      </div>
      {valor.pago && (
        <div className="grid gap-2 sm:grid-cols-2">
          <label>
            <span className={rotulo}>Pago em</span>
            <input type="date" value={valor.pagoEm} onChange={(e) => onChange({ ...valor, pagoEm: e.target.value })} className={campo} />
          </label>
          <label>
            <span className={rotulo}>Forma</span>
            <select value={valor.forma} onChange={(e) => onChange({ ...valor, forma: e.target.value as FormaDePagamento | "" })} className={campo}>
              <option value="">Não informada</option>
              {FORMAS_DE_PAGAMENTO.map((f) => (
                <option key={f} value={f}>
                  {FORMA_DE_PAGAMENTO_LABELS[f]}
                </option>
              ))}
            </select>
          </label>
        </div>
      )}
    </div>
  );
}
